import React, { useEffect, useRef, useState } from "react";

/**
 * Scroll-triggered reveal wrapper mimicking Elementor entrance animations.
 * animation: fadeInUp | fadeInDown | fadeInLeft | fadeInRight | rubberBand | zoomIn
 */
const Reveal = ({
  children,
  animation = "fadeInUp",
  delay = 0,
  className = "",
  as: Tag = "div",
  once = true,
}) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisible(true);
            if (once) observer.unobserve(entry.target);
          } else if (!once) {
            setVisible(false);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, [once]);

  return (
    <Tag
      ref={ref}
      className={`reveal reveal-${animation} ${visible ? "is-visible" : ""} ${className}`}
      style={{ animationDelay: `${delay}ms` }}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
